import Vue from 'vue'
import Router from 'vue-router'
// 路由数据
import routes from '../routerConfig';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js